import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Component, Inject, isDevMode, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { TwilioService } from 'src/app/+home/shared/services/twilio.service';
import { PdfViewerComponent } from 'src/app/viewer';
import { WorkflowService } from 'src/app/viewer/shared/services/workflow.service';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { NodesService } from '../services/nodes.service';

@Component({
  selector: 'dialog-sign-document',
  templateUrl: './dialog-sign-document.component.html',
  styleUrls: ['./dialog-sign-document.component.scss']
})
export class DialogSignDocumentComponent implements OnInit {
  public file: any;
  public blobFile: any;
  public globalForm: FormGroup;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  public loadingRequest: boolean;
  public errorCode: boolean;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('signature') signature: SignaturePadComponent;
  @ViewChild('paraph') paraph: SignaturePadComponent;
  @ViewChild('pdfViewer') pdfViewer: PdfViewerComponent;
  public contentSignature: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogSignDocumentComponent>,
    private fb: FormBuilder,
    private twilio: TwilioService,
    private workflowService: WorkflowService,
    private nodeService: NodesService,
    private storage: StorageService
  ) { }

  async ngOnInit(): Promise<void> {
    this.file = this.data.file;

    this.globalForm = this.fb.group({
      sid: [''],
      condtionForm:this.fb.group({
       accept:['', Validators.required]
      }),
      phoneForm: this.fb.group({
        phone: [isDevMode() ? '' : '', Validators.required]
      }),
      codeForm: this.fb.group({
        digit1: [isDevMode() ? '' : '', [Validators.required, Validators.pattern("^[0-9]$")]],
        digit2: [isDevMode() ? '' : '', [Validators.required, Validators.pattern("^[0-9]$")]],
        digit3: [isDevMode() ? '' : '', [Validators.required, Validators.pattern("^[0-9]$")]],
        digit4: [isDevMode() ? '' : '', [Validators.required, Validators.pattern("^[0-9]$")]],
      }),
      signature: this.fb.group({
        // signaturePlace: ['left', Validators.required],
        sign: [null, Validators.required]
      }),
      positions: this.fb.group({
        signaturePositions: [null, Validators.required]
      }),
      paraph: this.fb.group({
        paraphPlace: ['left'],
        paraph: [null]
      })
    });

    const token = this.storage.getAsync({ key: "token" });
    this.blobFile = await this.nodeService.loadFile(this.file.id, token, false);
  }

  async verifyNumber() {
    if (isDevMode) { // Si environnement de dev, sauter l'étape de demane du numéro puis de vérification
      this.stepper.next();
      (this.globalForm.get('codeForm') as FormControl).setValue({ digit1: 1, digit2: 2, digit3: 3, digit4: 4 });
      return;
    }

    this.loadingRequest = true;
    const res: any = await this.twilio.verifyNumber(this.globalForm.get('phoneForm').get('phone').value.e164Number);
    this.globalForm.get('sid').setValue(res.sid);
    this.loadingRequest = false;
    this.stepper.next();
  }

  accept(){
    this.stepper.next();

  }

  async verifyCode() {
    if (isDevMode) {
      this.stepper.next();
      return;
    }

    this.errorCode = false;
    this.loadingRequest = true;
    const { digit1, digit2, digit3, digit4 } = this.globalForm.get('codeForm').value;

    const res: any = await this.twilio.verifyCode(`${digit1}${digit2}${digit3}${digit4}`, this.globalForm.get('sid').value);
    this.loadingRequest = false;

    if (res) {
      this.stepper.next();
    } else {
      this.errorCode = true;
      this.clearAllCode();
    }
  }

  private clearAllCode() {
    this.globalForm.get('codeForm').get('digit1').setValue(null);
    this.globalForm.get('codeForm').get('digit2').setValue(null);
    this.globalForm.get('codeForm').get('digit3').setValue(null);
    this.globalForm.get('codeForm').get('digit4').setValue(null);
  }

  public clearSignature() {

    this.signature.clear();

  }
  public clearParaph() {

    this.paraph.clear();
  }

  public validateSignature() {
    this.contentSignature = this.signature.toDataURL("image/png");
    this.stepper.next();
  }

  public validatePositionSign() {
    const positions = this.pdfViewer.dragDropDirective.getSignPositionsForPages();
    this.globalForm.get('positions').get('signaturePositions').setValue(positions);
    this.stepper.next();
  }

  public async validateAll() {
    this.loadingRequest = true;
    const nodeRef = "workspace://SpacesStore/" + this.file.id;

    const contentParaph = this.paraph.toDataURL("image/png");
    const positionParaph = this.globalForm.get('paraph').get('paraphPlace').value;
    const signaturePositions = this.globalForm.get('positions').get('signaturePositions').value;

    await this.workflowService.sign({ contentSignature: this.contentSignature, contentParaph, nodeRef: nodeRef, signaturePositions, positionParaph })
      .subscribe(res => {
        this.dialogRef.close(true);
      },
        error => {
          this.dialogRef.close(false);
        });
    this.loadingRequest = false;

  }
}
